import { Injectable } from '@angular/core';

import {BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ProgressService {

    /**
     * sabject zmina
     */
    private sub: BehaviorSubject<any> = new BehaviorSubject<any>(null);


    private counter = 0;

    /**
     * ustawienie stanu dla konkretnego elementu
     */
    public setState(flag: boolean, name?: string) {


        if (flag === true) {
            this.counter++;
        } else {
            this.counter--;
        }
        if (this.counter < 0) {
            this.counter = 0;
        }

        this.notify();
    }

    private notify() {
        // przekazanie
        this.sub.next({
            inProgress: this.counter > 0
        });
    }

    public forceStop(): void {
        this.counter = 0;
        this.notify();
    }

    public getStateChange(): Observable<any> {
        return this.sub.asObservable();
    }

}
